import type {
  ClientPackageType,
  DeviceStatResponseType,
  deviceDetailType,
  deviceDetailsType,
  editDeviceDetailsType,
  newDeviceType,
  IsDeviceOnlineResponseType,
} from "utils";
import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";
import { getAppConfiguration } from "appConfig";

const endpoint = "/api/Device";

export async function getDevices<T>(startDate: T, endDate: T) {
  return axiosFetch.get(
    `${endpoint}/getAvailableDevices/${startDate as string}/${
      endDate as string
    }`
  );
}

export async function getDeviceList() {
  const appConfiguration = await getAppConfiguration();
  // összes eszköz lekérése
  return axiosFetch.get(
    `${endpoint}/getAllDevices/${appConfiguration.providerId}`
  );
}

export async function getCustomDeviceList(providerId: string) {
  return axiosFetch.get(`${endpoint}/getAllDevices/${providerId}`);
}

export async function getDeviceById(deviceId: string) {
  return axiosFetch.get(`${endpoint}/${deviceId}`);
}

export async function postDevice(
  body: deviceDetailType | newDeviceType | editDeviceDetailsType
) {
  return axiosFetch.post(`${endpoint}/upsert`, body);
}

export async function upsertDevicePrice(body: deviceDetailsType) {
  return axiosFetch.post("/api/devicePrice/upsert", body);
}

export async function deleteDevicePrice(id: string) {
  return axiosFetch.del(`/api/devicePrice/${id}`);
}

export async function isDeviceOnline(
  deviceId: string
): Promise<IsDeviceOnlineResponseType> {
  if (!deviceId || deviceId === "00000000-0000-0000-0000-000000000000") {
    return { active: false } as IsDeviceOnlineResponseType;
  }
  return axiosFetch.get(`${endpoint}/isDeviceOnline/${deviceId}`);
}

export async function getDeviceStat(): Promise<DeviceStatResponseType[]> {
  return axiosFetch.get(`${endpoint}/deviceStat`);
}

export async function getClientPackages(): Promise<ClientPackageType[]> {
  return axiosFetch.get(`${endpoint}/clientPackages`);
}

export async function setTargetPackage(
  deviceIds: string[],
  blobName: string | null
): Promise<void> {
  await axiosFetch.post(`${endpoint}/setTargetPackage`, {
    deviceIds,
    blobName,
  });
}

export async function requestDeviceLog(
  deviceIds: string[],
  debug = false
): Promise<void> {
  await axiosFetch.post(`${endpoint}/requestLog`, {
    deviceIds,
    debug,
  });
}

export async function cancelDeviceLogRequest(
  deviceIds: string[]
): Promise<void> {
  await axiosFetch.post(`${endpoint}/cancelLog`, {
    deviceIds,
  });
}
